<template>
  <div class="culture">
    <div class="nwrap">
      <div class="nei_ban">
        <h3>{{$t('m.culture')}}<p></p>
        </h3>
      </div>
      <div class="clear ptb3"></div>
      <div class="mainbox wrap">
        <h4 class="wht tit2">{{$t('m.culture')}}</h4>
        <i class="whi tit2i"></i>
        <ul class="whlist clearfix">
          <li class="li1">
            <h5>{{$t('m.cultureIdea')}}</h5>
            <p>{{$t('m.cultureIdeaInfo')}}</p>
          </li>
          <li class="li2">
          </li>
          <li class="li3">
            <h5>{{$t('m.mission')}}</h5>
            <p>{{$t('m.missionInfo')}}</p>
            </li>
          <li class="li4">
          </li>
          <li class="li5">
          </li>
          <li class="li6">
            <h5>{{$t('m.vision')}}</h5>
            <p>{{$t('m.visionInfo')}}</p>
          </li>
          <li class="li7">
          </li>
          <li class="li8">
            <h5>{{$t('m.value')}}</h5>
            <p>{{$t('m.valueInfo')}}</p>
          </li>
          <div class="clear"></div>   
        </ul>
        <div class="clear"></div>    
      </div>
      <div class="whad">
        <h2>{{$t('m.target')}}</h2>
      </div>
      <div class="clear ptb2">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.culture .nei_ban {
  clear: both;
  width: 100%;
  background: url(../assets/image/1-200429110R2X4.jpeg );
  height: 270px;
}
.culture .nei_ban {
  background-size: cover!important;
}
.culture .nei_ban h3 {
  text-align: center;
  width: 100%;
  clear: both;
  font-size: 48px;
  color: #FFF;
  font-weight: normal;
  padding-top: 105px;
}
.culture .nei_ban p {
  font-size: 24px;
  color: #FFF;
  text-transform: uppercase;
}
.culture .clear {
  height: 0;
  clear: both;
  zoom: 1;
}
.culture .ptb3 {
  padding-top: 3%;
}
.culture .wrap {
  width: 1200px;
  margin: 0 auto;
}
.culture h4.tit2 {
  color: #333;
  font-size: 30px;
  text-align: center;
  margin-top: 35px;
}
.culture i.tit2i {
  display: block;
  width: 60px;
  height: 2px;
  margin: 0 auto;
  background: #0062b1;
  margin-top: 22px;
  margin-bottom: 48px;
}
.culture ul.whlist li.li1 {
  background: url(../assets/image/wximg1.jpg) no-repeat;
}
.culture ul.whlist li.li2 {
  background: url(../assets/image/wximg2.jpg) no-repeat;
}
.culture ul.whlist li.li3 {
  background: url(../assets/image/wximg3.jpg) no-repeat;
}
.culture ul.whlist li.li4 {
  background: url(../assets/image/wximg4.jpg) no-repeat;
}
.culture ul.whlist li.li5 {
  background: url(../assets/image/wximg5.jpg) no-repeat;
}
.culture ul.whlist li.li6 {
  background: url(../assets/image/wximg6.jpg) no-repeat;
}
.culture ul.whlist li.li7 {
  background: url(../assets/image/wximg7.jpg) no-repeat;
}
.culture ul.whlist li.li8 {
  background: url(../assets/image/wximg8.jpg) no-repeat;
}
.culture ul.whlist li {
  width: 299px;
  height: 413px;
  float: left;
}
.culture ul.whlist li h5 {
  font-size: 20px;
  color: #222;
  text-align: center;
  margin-top: 160px;
}
.culture ul.whlist li p {
  color: #666;
  font-size: 16px;
  width: 85%;
  text-align: center;
  margin: 0 auto;
  margin-top: 22px;
}
.culture .whad {
  height: 233px;
  background: url(../assets/image/fwptimg.jpg) no-repeat center center;
  margin-top: 85px;
  overflow: hidden;
  margin-bottom: 40px;
}
.culture .whad h2 {
  color: #fff;
  font-size: 36px;
  text-align: center;
  margin-top: 98px;
}
.culture .clear {
  height: 0;
  clear: both;
  zoom: 1;
}
.culture .ptb2 {
  padding-top: 2%;
}

@media (max-width: 1230px) {
.culture .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.culture ul.whlist li {
  width:33.333%;
  background-size: cover !important;
  margin-bottom: 5px;
}
}
@media (max-width: 1000px) {
.culture .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
}
@media (max-width: 992px) {
.culture .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.culture ul.whlist li {
  width:50%;
  background-size: cover !important;
  margin-bottom: 5px;
}

}
@media (max-width: 768px) {
.culture .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.culture .whad h2 {
  font-size: 24px;
  margin-top: 95px;
}
.culture ul.whlist li {
  width: 100%;
  background-size: cover !important;
  margin-bottom: 5px;
}
}


</style>